<template>
  <div class="defalut-container">
    <div class="main-container" :class="{'full-style':fullBoxScreen}">
      <el-card class="recommended-tools-container" v-show="!fullBoxScreen">
        <h3 class="title">
          <span>工具箱</span>
        </h3>
        <div class="tools-card">
          <div class="tools-card-item" @click="changeTools('upload')" :class="{'active':this.cardType==='upload'}">
            <img class="card-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/file_cloud_manage.png" alt="">
            <strong class="card-title">文件上传</strong>
            <div class="card-desc">XPS文件上传，支持200M内所有类型文件。</div>
          </div>
          <div class="tools-card-item" @click="changeTools('project')" :class="{'active':this.cardType==='project'}">
            <img class="card-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/project_manage.png" alt="">
            <strong class="card-title">我的项目</strong>
            <div class="card-desc">查看我参与或创建的项目，以项目维度管理文件。</div>
          </div>
          <div class="tools-card-item" @click="changeTools('handle')" :class="{'active':this.cardType==='handle'}">
            <img class="card-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/device_setting.png" alt="">
            <strong class="card-title">图片处理</strong>
            <div class="card-desc">将图片进行缩放、裁剪等操作，支持预览和下载。</div>
          </div>
        </div>

      </el-card>
      <el-card class="upload-files-container" body-style="height:100%;">
        <FunctionCard :active="cardType" />
      </el-card>
    </div>
    <div class="right-sider-bar" v-show="!fullBoxScreen">
      <el-card class="activity-chart-container" body-style="padding-bottom:0; height:100%;">
        <h3 class="title">
          <span>上传图表</span>
        </h3>
        <div id="upload-chart"></div>
      </el-card>
      <el-card class="latest-files-container" body-style="height:100%">
        <h3 class="title header-box">
          <span>项目文件</span>
          <el-select @change="changeProject" class="select" v-model="path" placeholder="请选择项目" clearable :style="{width:'202px'}">
            <el-option v-for="item in projectList" :key="item.id" :label="item.projectName" :value="item.path">
            </el-option>
          </el-select>
          <!-- <el-input-number class="count" :controls="true" controls-position="right" :min="10" :max="200" size="mini" v-model="count" :step="5" step-strictly @change="getLatestFileList"></el-input-number> -->
        </h3>
        <div v-if="latestFileList.length>0" class="content file-page-container" v-infinite-scroll="load">
          <div v-for="item in latestFileList" :key="item.id" class="latest-file-card">
            <img class="file-image" v-if="item.isImg" :src="item.url" slot="cover" />
            <div v-else class="file-icon" :class="`file-icon-${item.ext}`"></div>
            <div class="file-content">
              <div class="name text-overflow-ellipsis">{{item.filename}}</div>
              <div class="time text-overflow-ellipsis">{{formatTime(item.createTime||item.time)}}</div>
            </div>
            <div class="file-copy">
              <el-tooltip effect="dark" content="复制图片webp格式地址" placement="left">
                <el-button v-if="item.isImg" type="text" v-clipboard:copy="item.url+'?imageMogr2/format/webp'" v-clipboard:success="onCopy">webp</el-button>
              </el-tooltip>
              <el-button type="text" v-clipboard:copy="item.url" v-clipboard:success="onCopy">复制</el-button>
              <el-button type="text" @click="downloadFile(item)">下载</el-button>
            </div>
          </div>
        </div>
        <div class="empty-content other-url" v-else>
          <p class="empty-text">最近无上传文件哦~</p>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { myFilesApi, xpsApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { downloadFile } from '@/common/utils/download.js';
import { getExt, isImg } from '@/common/utils/ext.js';
import FunctionCard from './functionCard/index.vue';
import { mapGetters } from 'vuex'
export default {
  components: {
    FunctionCard
  },
  data () {
    return {
      cardType: 'upload',
      count: 10,
      path: '',
      fileType: '',
      latestFileList: [],
      projectList: []
    }
  },
  computed: {
    ...mapGetters(['fullBoxScreen'])
  },
  mounted () {
    this.getMyFilesTypeCount();
    this.getProjectList();
    this.getLatestFileList();
    this.cardType = localStorage.getItem('XPS_TOOLS_ACTIVE') || 'upload';
  },
  methods: {
    // 获取项目列表
    async getProjectList () {
      showLoading();
      const res = await myFilesApi.getMyProjects();;
      if (res.code === 200) {
        this.projectList = res.data;
      } else {
        this.$message.error('服务异常！')
      }
      hideLoading();
      this.loading = false;
    },
    // 选择工具卡片触发
    changeTools (cardType) {
      localStorage.setItem('XPS_TOOLS_ACTIVE', cardType);
      // this.selectActiveCard(e);
      this.cardType = cardType;
    },
    // 选中活跃卡片
    // selectActiveCard (e) {
    //   const dom = e.currentTarget;
    //   const toolsCardItem = document.querySelector('.tools-card-item.active');
    //   if (toolsCardItem) toolsCardItem.classList.remove('active');
    //   dom.classList.add('active');
    // },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 下载
    downloadFile (file) {
      downloadFile(file.url, file.filename);
    },
    async getMyFilesTypeCount () {
      showLoading();
      const res = await myFilesApi.getMyFilesTypeCount()
      if (res.code === 200) {
        this.fileType = this.initChartData(res.data);
        this.initChart();
      }
      hideLoading();
    },
    load () {
      this.count = this.count + 10;
      if (this.count > 200) {
        return this.$message.warning('最多支持查询最近200个文件哦~')
      }
      this.getLatestFileList();
    },
    changeProject () {
      this.count = 10;
      this.getLatestFileList();
    },
    // 获取最近上传文件列表
    async getLatestFileList () {
      if (!this.count) {
        this.$nextTick(() => {
          this.count = 10;
        })
      }
      const count = this.count ? this.count : 10
      showLoading();
      const res = await xpsApi.getLatestFileList({ count, path: this.path });
      if (res) {
        res.list.forEach(item => {
          item.isImg = isImg(item.url);
          item.ext = getExt(item.url);
        })
        this.latestFileList = res.list;
      }
      hideLoading();
    },
    // 初始化图表数据
    initChartData (data) {
      let result = [];
      for (let k in data) {
        const obj = {};
        obj.value = data[k];
        obj.name = this.convertChineseName(k);
        result.push(obj);
      }
      return result;
    },
    // 转换为中文名称
    convertChineseName (name) {
      let cName;
      switch (name) {
        case 'image':
          cName = '图片';
          break;
        case 'video':
          cName = '音视频';
          break;
        case 'txt':
          cName = '文本';
          break;
        case 'rar':
          cName = '压缩包';
          break;
        case 'html':
          cName = '网页';
          break;
        case 'iso':
          cName = '镜像文件';
          break;
        default:
          cName = '其他';
          break;
      }
      return cName;
    },
    // 初始化图表
    initChart () {
      const myChart = this.echarts.init(document.getElementById('upload-chart'));
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '75%',
        },
        series: [
          {
            name: '上传数量',
            type: 'pie',
            radius: ['40%', '70%'],
            center: ['50%', '35%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '16',
                fontWeight: 'bold',
              }
            },
            labelLine: {
              show: false
            },
            data: this.fileType
          }
        ]
      };
      let currentIndex = -1;
      setInterval(function () {
        var dataLen = option.series[0].data.length;
        // 取消之前高亮的图形
        myChart.dispatchAction({
          type: 'downplay',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
        currentIndex = (currentIndex + 1) % dataLen;
        // 高亮当前图形
        myChart.dispatchAction({
          type: 'highlight',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
        // 显示 tooltip
        myChart.dispatchAction({
          type: 'showTip',
          seriesIndex: 0,
          dataIndex: currentIndex
        });
      }, 3000);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      })
    },
  }
}
</script>

<style lang="scss">
.defalut-container {
  display: flex;
  width: 100%;
  height: 100%;
  .title {
    position: relative;
    margin: 0 0 15px 10px;
    &.header-box {
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      .select {
        width: 90px;
        margin-right: 10px;
      }
    }
    > span {
      position: relative;
      z-index: 2;
    }
    &::before {
      position: absolute;
      content: "";
      width: 24px;
      height: 24px;
      background-color: #e8f2ff;
      border-radius: 50%;
      left: -13px;
    }
  }
  .right-sider-bar {
    width: 40%;
    .activity-chart-container {
      margin-bottom: 10px;
      height: 300px;
      #upload-chart {
        width: 100%;
        height: calc(100% - 40px);
      }
    }
    .latest-files-container {
      height: calc(100% - 310px);
      position: relative;
      // width: 50%;
      .empty-content {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        height: 220px;
        background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/1737927985.png");
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: center;
        .empty-text {
          font-weight: 500;
          color: #bcbcbc;
        }
      }
      .empty-content.other-url {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        background-image: url("https://front-xps-cdn.xsyx.xyz/2021/10/22/973595372.png");
      }
      .content {
        height: calc(100% - 28px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          display: none;
        }
      }
      .latest-file-card {
        display: flex;
        margin: 0 10px 10px 10px;
        justify-content: space-between;
        align-items: center;
        .file-icon {
          margin-right: 15px;
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
        }
        .file-image {
          margin-right: 15px;
          width: 40px;
          height: 40px;
          border-radius: 8px;
        }
        .file-content {
          flex: 3;
          color: #041677;
          .name {
            font-weight: 600;
          }
          .time {
            margin-top: 2px;
            font-size: 10px;
            color: #adb4bf;
          }
        }
        .file-copy {
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-end;
          margin-right: 10px;
          text-align: right;
          flex: 1;
        }
      }
    }
  }

  .main-container {
    width: 60%;
    transition: all ease 0.5s;
    &.full-style {
      width: 100%;
      .upload-files-container {
        height: 100%;
        margin: 0;
      }
      .function-upload-container .xps-upload {
        .el-upload-dragger {
          height: 300px !important;
        }
        .upload-icon {
          font-size: 130px !important;
          &.el-icon-upload {
            margin-top: 90px !important;
          }
        }
      }
    }
    .recommended-tools-container {
      margin: 0 20px 10px 0;
      height: 300px;
      .tools-card {
        display: flex;
        height: 220px;
        flex-flow: row wrap;
        overflow-x: auto;
        &-item {
          margin-bottom: 10px;
          margin-right: 10px;
          padding: 10px;
          min-width: 230px;
          width: calc(33% - 10px);
          height: 100px;
          border-radius: 10px;
          background-color: #fbfbfb;
          cursor: pointer;
          transition: all 0.3s;
          // background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-gray-bg.webp");
          background-repeat: no-repeat;
          .card-desc {
            margin-top: 10px;
            font-size: 12px;
            color: #adb4bf;
          }
          &.active {
            background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-bg.webp");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            .card-title {
              color: #041677;
            }
          }
          .card-image {
            float: left;
            margin-right: 20px;
            width: 90px;
            object-fit: contain;
          }
          &:hover {
            background-color: #f7f6f9;
          }
        }
        &::-webkit-scrollbar {
          display: none;
        }
      }
    }
    .upload-files-container {
      margin: 0 20px 10px 0;
      height: calc(100% - 310px);
    }
  }
}
</style>